import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import NewMonitor from './pages/NewMonitor';
import MonitorDetails from './pages/MonitorDetails';
import SubMonitorDetails from './pages/SubMonitorDetails';
import GeoMonitorDetails from './pages/GeoMonitorDetails';
import WorkPlanPage from './pages/WorkPlanPage';
import BillingPage from './pages/BillingPage';
import PricingPage from './pages/PricingPage';
import SupportPage from './pages/SupportPage';
import AdminPanel from './pages/AdminPanel';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import PublicAudit from './pages/PublicAudit';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route path="/register" element={<AuthPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/audit" element={<PublicAudit />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/new"
            element={
              <ProtectedRoute>
                <NewMonitor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/:id"
            element={
              <ProtectedRoute>
                <MonitorDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/:monitorId/product/:submonitorId"
            element={
              <ProtectedRoute>
                <SubMonitorDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/:monitorId/geo/:geoId"
            element={
              <ProtectedRoute>
                <GeoMonitorDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor/:monitorId/workplan"
            element={
              <ProtectedRoute>
                <WorkPlanPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <ProtectedRoute>
                <BillingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pricing"
            element={
              <ProtectedRoute>
                <PricingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <SupportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;